import { EditorTabs } from './EditorTabs.js';

export function ResumeEditor() {
  return <EditorTabs />;
}
